import React from 'react';
import { Star, User } from '@phosphor-icons/react';

export default function ReviewsSection({ reviews, averageRating, totalReviews }) {
  if (!reviews || reviews.length === 0) {
    return (
      <div className="bg-[#121212] border border-white/10 p-6">
        <h3 className="text-xl font-serif text-white mb-4">Reviews</h3>
        <div className="text-center py-8">
          <Star size={48} className="mx-auto text-zinc-600 mb-3" weight="duotone" />
          <p className="text-zinc-500">No reviews yet</p>
          <p className="text-zinc-600 text-sm mt-1">Be the first to book and leave a review!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#121212] border border-white/10 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-serif text-white">Reviews</h3>
        <div className="flex items-center gap-2">
          <Star size={24} weight="fill" className="text-[#D4AF37]" />
          <span className="text-2xl font-bold text-white">{averageRating?.toFixed(1) || '0.0'}</span>
          <span className="text-zinc-500">({totalReviews} review{totalReviews !== 1 ? 's' : ''})</span>
        </div>
      </div>

      {/* Rating Distribution */}
      <div className="mb-6 space-y-2">
        {[5, 4, 3, 2, 1].map((star) => {
          const count = reviews.filter(r => r.rating === star).length;
          const percentage = reviews.length > 0 ? (count / reviews.length) * 100 : 0;
          return (
            <div key={star} className="flex items-center gap-3">
              <span className="text-zinc-400 w-8">{star} ★</span>
              <div className="flex-1 h-2 bg-[#0A0A0A] rounded-full overflow-hidden">
                <div
                  className="h-full bg-[#D4AF37] rounded-full transition-all"
                  style={{ width: `${percentage}%` }}
                />
              </div>
              <span className="text-zinc-500 w-8 text-right">{count}</span>
            </div>
          );
        })}
      </div>

      {/* Review List */}
      <div className="space-y-6">
        {reviews.map((review) => (
          <div key={review.id} className="border-t border-white/10 pt-6 first:border-0 first:pt-0">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                <User size={20} className="text-[#D4AF37]" weight="duotone" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <p className="text-white font-medium">{review.reviewer_name}</p>
                    <p className="text-zinc-500 text-sm">
                      {new Date(review.created_at).toLocaleDateString('en-US', {
                        month: 'long',
                        year: 'numeric'
                      })}
                    </p>
                  </div>
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star
                        key={star}
                        size={16}
                        weight={star <= review.rating ? 'fill' : 'regular'}
                        className={star <= review.rating ? 'text-[#D4AF37]' : 'text-zinc-600'}
                      />
                    ))}
                  </div>
                </div>
                <p className="text-zinc-300 leading-relaxed">{review.comment}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
